import { MenuContent } from '@chakra-ui/react';
import type { ReactNode } from 'react';

interface HeaderMenuProps {
  children: ReactNode;
}

/**
 * Standardized menu wrapper for header dropdowns
 * Provides consistent positioning and styling
 */
export default function HeaderMenu({ children }: HeaderMenuProps) {
  return (
    <MenuContent
      position="absolute"
      top="100%"
      right="0"
      mt={2}
      zIndex={200}
      bg="bg.surface"
      border="1px solid"
      borderColor="border.muted"
      shadow="md"
      borderRadius="lg"
      minW="210px"
      p={1}
    >
      {children}
    </MenuContent>
  );
}
